module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 12 12",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_6985_159356)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.6412 9.36797C10.3886 8.76954 10.0219 8.22596 9.56175 7.76752C9.10296 7.30776 8.55947 6.94119 7.96131 6.68806C7.95595 6.68538 7.95059 6.68404 7.94523 6.68136C8.77961 6.07868 9.32202 5.09699 9.32202 3.9894C9.32202 2.15458 7.83541 0.667969 6.00059 0.667969C4.16577 0.667969 2.67916 2.15458 2.67916 3.9894C2.67916 5.09699 3.22157 6.07868 4.05595 6.6827C4.05059 6.68538 4.04523 6.68672 4.03988 6.6894C3.43988 6.94252 2.90148 7.30547 2.43943 7.76886C1.97967 8.22766 1.6131 8.77114 1.35997 9.36931C1.11129 9.95492 0.977174 10.5828 0.964877 11.2189C0.96452 11.2332 0.967027 11.2474 0.972251 11.2607C0.977475 11.274 0.985311 11.2861 0.995296 11.2964C1.00528 11.3066 1.01721 11.3147 1.03039 11.3203C1.04357 11.3258 1.05772 11.3287 1.07202 11.3287H1.87559C1.93452 11.3287 1.9814 11.2818 1.98273 11.2242C2.00952 10.1903 2.4247 9.22199 3.15863 8.48806C3.918 7.72868 4.92648 7.31083 6.00059 7.31083C7.0747 7.31083 8.08318 7.72868 8.84256 8.48806C9.57648 9.22199 9.99166 10.1903 10.0184 11.2242C10.0198 11.2831 10.0667 11.3287 10.1256 11.3287H10.9292C10.9435 11.3287 10.9576 11.3258 10.9708 11.3203C10.984 11.3147 10.9959 11.3066 11.0059 11.2964C11.0159 11.2861 11.0237 11.274 11.0289 11.2607C11.0342 11.2474 11.0367 11.2332 11.0363 11.2189C11.0229 10.5787 10.8903 9.95592 10.6412 9.36797V9.36797ZM6.00059 6.29297C5.38586 6.29297 4.80729 6.05324 4.37202 5.61797C3.93675 5.1827 3.69702 4.60413 3.69702 3.9894C3.69702 3.37467 3.93675 2.79609 4.37202 2.36083C4.80729 1.92556 5.38586 1.68583 6.00059 1.68583C6.61532 1.68583 7.19389 1.92556 7.62916 2.36083C8.06443 2.79609 8.30416 3.37467 8.30416 3.9894C8.30416 4.60413 8.06443 5.1827 7.62916 5.61797C7.19389 6.05324 6.61532 6.29297 6.00059 6.29297Z",
      "fill": "black",
      "fill-opacity": "0.85"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_6985_159356"
    }
  }, [_c('rect', {
    attrs: {
      "width": "12",
      "height": "12",
      "fill": "white"
    }
  })])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4afadb2f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4afadb2f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/User.vue
// module id = 1492
// module chunks = 159